import React from 'react';
export function StickyHeader() {
  return <div className="sticky top-0 z-40 flex min-h-[36px] w-full items-center justify-center bg-gold px-4 py-2 text-center" data-id="element-177" data-mp="2zb2qzvd4yfy0">
      <p className="text-[11px] font-semibold leading-snug text-navy sm:text-xs" data-id="element-178" data-mp="14tt0h0epalvt">
        <span className="sm:hidden" data-id="element-179" data-mp="1iqg8by86ywgi">Visual Arts Resources in English · Made for Art Teachers</span>
        <span className="hidden sm:inline" data-id="element-180" data-mp="1dsy2whtduzd9">
          Visual Arts Resources · Made for Art Teachers · Instant Digital Access
        </span>
      </p>
    </div>;
}